
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
name: "edit-pic",
components: {
XHeader
},
data(){
return{
headImg:'',

crap: false,
previews: {},
option: {
img: '',
outputSize:1, //剪切后的图片质量（0.1-1）
full: false,//输出原图比例截图 props名full
outputType: 'png',
canMove: true,
original: false,
canMoveBox: true,
autoCrop: true,
autoCropWidth: 150,
autoCropHeight: 150,
fixedBox: true
},
fileName:'',  //本机文件地址
downImg: '#',
imgFile:'',
uploadImgRelaPath:'', //上传后的图片的地址（不带服务器域名）
}
},
created(){

},
methods:{

finish(type) {
console.log('finish')
let _this = this;
let formData = new FormData();

if (type === 'blob') {
this.$refs.cropper.getCropBlob((data) => {
let img = window.URL.createObjectURL(data)
this.model = true;
this.modelSrc = img;
formData.append("file", data, this.fileName);
this.$http.post(Api.uploadSysHeadImg.url, formData, {contentType: false, processData: false, headers:{'Content-Type': 'application/x-www-form-urlencoded'}})
.then((response)=>{
var res = response.data;
if(res.success == 1){
$('#btn1').val('');
_this.imgFile = '';
_this.headImg = res.realPathList[0];  
_this.uploadImgRelaPath = res.relaPathList[0];  
_this.$message({　　//element-ui的消息Message消息提示组件
type: 'success',
message: '上传成功'
});
}
})
})
} else {
this.$refs.cropper.getCropData((data) => {
this.model = true;
this.modelSrc = data;
})
}
},

realTime(data) {
console.log('realTime')
this.previews = data
},


uploadImg(e, num) {
console.log('uploadImg');
var _this = this;

var file = e.target.files[0]
_this.fileName = file.name;
if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
return false
}
var reader = new FileReader();
reader.onload =(e) => {
let data;
if (typeof e.target.result === 'object') {

data = window.URL.createObjectURL(new Blob([e.target.result]))
}
else {
data = e.target.result
}
if (num === 1) {
_this.option.img = data
} else if (num === 2) {
_this.example2.img = data
}
}



reader.readAsArrayBuffer(file);

},
imgLoad (msg) {
console.log('imgLoad')
console.log(msg)
}
}
}



// WEBPACK FOOTER //
// ./src/components/EditPic.vue